import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AiOutlineLeft  } from 'react-icons/ai'; // Left arrow icon from React Icons
import './LogoHome.css';

const LogoHome = () => {
  const location = useLocation();

  return (
    <div className="logo-home-container">
      {/* Left Arrow Icon (hidden on homepage) */}
      {location.pathname !== '/' && (
        <Link to="/" className="home-icon">
          <AiOutlineLeft  />
        </Link>
)}


      {/* Logo and Logo Text */}
      <Link to="/" className="logo">
        <img
          src={require('../Crunch.png')} // Path to your logo file
          alt="Crunch App Logo"
          className="logo-image"
        />
        <span className="logo-text">Algoriddles</span>
      </Link>
    </div>
  );
};

export default LogoHome;
